import React, { useEffect } from "react";
import Sidebar from "../../components/common/Sidebar";
import RodeoEventPerformancePage from "../../components/events/rodeoEventPerformance/rodeoEventPerformancePage";
import { APPLICATION_NAME, RODEO_PAGE_NAME } from "../../_config";

export default function RodeoEventPerformanceContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Performance List`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.PERFORMANCE_LIST} />
        <RodeoEventPerformancePage />
      </section>
    </React.Fragment>
  );
}
